import { gql } from '@apollo/client';

const GET_TASK_LIST_HEADER_INFO = gql`
  query GetTaskListHeaderInfo($id: ID!) {
    viewer {
      __typename
      id
      taskList(id: $id) {
        __typename
        id
        uuid
        name
        category
        tasksCount
        tasksCompletedCount
        tasksSkippedCount
        updatedAt
        isPopulating
      }
    }
  }
`;

export default GET_TASK_LIST_HEADER_INFO;
